<script lang="ts">
  import SellSheetInfo from "@distributor/svelte/SellSheet/Components/SellSheetInfo.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import type { DistributorSellSheet } from "@shared/types/SellSheet";
  import dateHelpers from "@shared/filters/tiz_date.js";
  export let sellSheet: DistributorSellSheet;
  export let page;
  export let mobileMode: boolean;

  if (mobileMode == false) {
    page.showMetrics = true;
    page.showShares = true;
  }

  let errorState = null;
  let user = window["$rootScope"].user;

  const saveEdits = async function () {
    let method = "PUT";
    let url = "/api/distributor/sell_sheets/" + sellSheet.id;
    if (!sellSheet.id) {
      method = "POST";
      url = "/api/distributor/sell_sheets";
    }
    try {
      let res = await HttpPromise({
        method: method,
        url: url,
        data: sellSheet,
      });
      errorState = null;
      page.sellSheetCopy = res;
    } catch (error) {
      errorState = error;
    }
  };

  $: {
    page.showInfo = true;
    page.showShares = !mobileMode;
  }
</script>

<div
  class="{mobileMode
    ? ''
    : 'grid-col c12-12 c3-12--md float-left'} margin-bottom--smaller margin-bottom--small--md"
>
  <div class="margin-left--smaller--md margin-right--smaller--md">
    <div class="cart__item-header align-left padding--small background-white">
      <span class="default-body--regular default-subheader--regular--md">Sheet Info</span>
      {#if mobileMode}
        <a
          class="brand-body--bold cursor-pointer float-right color-brandPrimary expand-sheet-info"
          href={"#"}
          on:click={() => (page.showInfo = !page.showInfo)}
        >
          {page.showInfo ? "Collapse -" : "Expand +"}
        </a>
      {/if}
    </div>
    {#if page.showInfo}
      <SellSheetInfo {sellSheet} {saveEdits} {errorState} {user} />
    {/if}
    {#if sellSheet.shares.length > 0}
      <div
        class="cart__item-header align-left padding--small background-white margin-top--smaller margin-top--small--md"
      >
        <span class="default-body--regular default-subheader--regular--md"
          >{sellSheet.shares.length} Account{#if sellSheet.shares.length != 1}s{/if}</span
        >
        {#if mobileMode}
          <a
            class="brand-body--bold cursor-pointer float-right color-brandPrimary share-expand"
            href={"#"}
            on:click={() => (page.showShares = !page.showShares)}
          >
            {page.showShares ? "Collapse -" : "Expand +"}</a
          >
        {/if}
      </div>
    {/if}
    <!-- SHARE HISTORY START -->
    {#if !mobileMode || (page.showShares && !page.editing)}
      <div
        class="padding-left--small padding-right--small padding-bottom--small background-white ng-animation slide-in-out sellsheet-scrollbox"
        id="sell-sheet-share-list"
      >
        {#each sellSheet.shares as share}
          <div class="display-block full-width padding-top--small" id="share-{share.id}">
            {#if window["C"].APP_NAME === "supplier"}
              <span class="s5 strong"
                >{share.non_provi_account_details.name ||
                  share.shared_with_user.first_name + " " + share.shared_with_user.last_name}</span
              >
            {:else}
              <UIRouterLink
                classes="s5 strong color-brandPrimary underline-hover"
                stateName="layout.retailer_details"
                params={{ retailerId: share.shared_with_retailers[0]?.id }}
              >
                {share.non_provi_account_details.name ||
                  share.shared_with_user.first_name + " " + share.shared_with_user.last_name}
              </UIRouterLink>
            {/if}
            {#each share.shared_with_retailers as retailer}
              <div class="s5">{retailer.name}</div>
              <div class="s6 strong color-grayDark"
                >Share by {share.share_method} on {dateHelpers.tiz_date()(share.created_at)}</div
              >
            {/each}
          </div>
        {/each}
      </div>
    {/if}
    <!-- SHARE HISTORY END -->

    <!-- METRICS START -->

    {#if page.totalViewsSum > 0 || page.productsPurchasedSum > 0}
      <div
        class="cart__item-header align-left padding--small background-white margin-top--smaller margin-top--small--md"
      >
        <span class="default-body--regular default-subheader--regular--md">Metrics</span>
        {#if !mobileMode}
          <a
            class="brand-body--bold cursor-pointer float-right color-brandPrimary metrics-expand"
            href={"#"}
            on:click={() => (page.showMetrics = !page.showMetrics)}
          >
            {page.showMetrics ? "Collapse -" : "Expand +"}
          </a>
        {/if}
      </div>
    {/if}

    {#if (page.totalViewsSum > 0 || page.productsPurchasedSum > 0) && (!mobileMode || (page.showMetrics && !page.editing))}
      <div
        class="padding-left--small padding-right--small padding-bottom--small background-white ng-animation slide-in-out sellsheet-scrollbox"
      >
        <!-- tabs -->
        <ul
          class="tabs no-tab-border list list--horizontal list--gutter-none margin-bottom--small margin-left--small margin-right--small align-center"
        >
          <li class="list-item secondary-body--small secondary-body--regular--md">
            <div
              class="capitalize cursor-pointer tabs__tab padding--smaller"
              class:tabs__tab--active={page.selectedMetricsTab == "views"}
              on:click={() => (page.selectedMetricsTab = "views")}
            >
              <div class="s3">{page.totalViewsSum}</div>
              Total Views
            </div>
          </li>
          <li class="list-item secondary-body--small secondary-body--regular--md">
            <div
              class="capitalize cursor-pointer tabs__tab padding--smaller"
              class:tabs__tab--active={page.selectedMetricsTab == "products"}
              on:click={() => (page.selectedMetricsTab = "products")}
            >
              <div class="s3">{page.productsPurchasedSum}</div>
              Products Sold
            </div>
          </li>
        </ul>
        <!-- // tabs -->

        {#if page.selectedMetricsTab == "views"}
          <div class="display-block full-width padding-top--small">
            {#each sellSheet.retailer_views as retailer}
              <div class="grid-row padding--smallest" id="retailer-view-{retailer.id}">
                <div class="grid-col c10-12">
                  {#if window["C"].APP_NAME === "supplier"}
                    <span class="s5 strong">{retailer.name}</span>
                  {:else}
                    <UIRouterLink
                      classes="s5 strong color-brandPrimary underline-hover"
                      stateName="layout.retailer_details"
                      params={{ retailerId: retailer.id }}
                    >
                      {retailer.name}
                    </UIRouterLink>
                  {/if}
                </div>
                <div class="grid-col c2-12">
                  <span class="s5">{retailer.non_unique_views}</span>
                </div>
              </div>
            {/each}
          </div>
        {/if}

        {#if page.selectedMetricsTab == "products"}
          <div class="display-block full-width padding-top--small">
            {#each sellSheet.retailer_purchases as retailer}
              <div class="grid-row padding--smallest" id="retailer-purchase-{retailer.id}">
                <div class="grid-col c10-12">
                  <UIRouterLink
                    classes="s5 strong color-brandPrimary underline-hover"
                    stateName="layout.retailer_details"
                    params={{ retailerId: retailer.id }}
                  >
                    {retailer.name}
                  </UIRouterLink>
                </div>
                <div class="grid-col c2-12">
                  <span class="s5">{retailer.products_purchased}</span>
                </div>
              </div>
            {/each}
          </div>
        {/if}
      </div>
    {/if}
    <!-- METRICS END -->
  </div>
</div>
